/**
 * Dernière méthode de connexion utilisée sur CET appareil.
 *
 * Sert à guider le retour d'un visiteur inscrit au salon : son compte a été
 * créé par code email, il n'a donc aucun mot de passe — mais rien, sur l'écran
 * de connexion, ne le lui rappelle trois semaines plus tard. On marque
 * discrètement la méthode qu'il avait employée plutôt que de le laisser buter
 * sur un champ mot de passe qui ne lui servira jamais.
 *
 * Purement local et cosmétique : cette valeur n'autorise rien, ne voyage pas
 * au serveur, et son absence (navigation privée, nouvel appareil) dégrade
 * simplement vers l'écran neutre.
 */

export type AuthMethod = 'google' | 'otp' | 'password';

const STORAGE_KEY = 'evinly.auth.lastMethod';

export function rememberAuthMethod(method: AuthMethod): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, method);
  } catch {
    /* navigation privée : on se passe du confort, rien de cassé */
  }
}

export function getLastAuthMethod(): AuthMethod | null {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === 'google' || v === 'otp' || v === 'password' ? v : null;
  } catch {
    return null;
  }
}
